<template>
    <div class="calculator lz">
        <div class="calculatorTitle">{{settings?.local?.singleOffer?.title}}</div>
        <div class="calculatorBlocks">
            <div class="moneyCalc">
                <div class="label">{{settings?.local?.singleOffer?.moneyCalcLabel}}</div>
                <vue-slider
                    v-model="calculatorValue"
                    v-bind="options"
                    @change="(value) => handeDrag(value, '.moneyCalc')"
                    @dragging="(value) => handeDrag(value, '.moneyCalc')"
                />
                <div class="total">
                    <div class="yuoGet">
                        {{settings?.local?.singleOffer?.yuoGet}}: <span>{{formatValue(total.get, true)}}</span>
                    </div>
                    <div class="percent">
                        {{settings?.local?.singleOffer?.percent}}: <span>{{formatValue(total.rate, false, true)}}%</span>
                    </div>
                </div>
            </div>
            <div class="termCalc">
                <div class="label">{{settings?.local?.singleOffer?.termCalcLabel}}</div>
                <vue-slider
                    v-model="termValue"
                    v-bind="termOptions"
                    @change="(value) => handeDrag(value, '.termCalc', 'minTerm', 'maxTerm')"
                    @dragging="(value) => handeDrag(value, '.termCalc', 'minTerm', 'maxTerm')"
                />
                <div class="total">
                    <div class="toBack">
                        {{settings?.local?.singleOffer?.toBack}}: <span>{{formatValue(total.get + total.overpayment, true)}}</span>
                    </div>
                    <div class="overpayment">
                        {{settings?.local?.singleOffer?.overpayment}}: <span>{{formatValue(total.overpayment, true)}}</span>
                    </div>
                </div>
            </div>
        </div>
        <a v-if="settings.local" data-target="target_goal_get_money" :href="settings?.url" type="button" class="submit getMoney" target="_blank">
            {{settings?.local.singleOffer?.getMoneyButton}}
        </a>
    </div>
</template>

<script setup>
import  VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import '@/assets/css/form.css';
import {onMounted, ref} from "vue";
import {ajax, setCookie, data, hasClass, getAllCookies, createLabel} from "@/assets/js/Functions";


const props = defineProps({
    element: Object
});

const settings = ref({})
let options = {}
let termOptions = {}

const calculatorValue = ref(0)
const termValue = ref(0)
const total = ref({
    get: 0,
    return: 0,
    overpayment: 0,
    term: 0,
    rate: 0
})

const calculateTotal = () => {
    total.value.get = calculatorValue.value
    total.value.term = termValue.value
    total.value.return = (((total.value.rate * total.value.term) / 100) * calculatorValue.value) + calculatorValue.value
    total.value.overpayment = total.value.return - total.value.get
}
const formattedSum = () => {
    return (parseInt(calculatorValue.value * rateValue.value)).toLocaleString()
}

const formatValue = (value, addCurrency = true, float = false) => {
    return (float ? value : parseInt(value)).toLocaleString() + (addCurrency && settings?.value?.currency ? ' ' + settings.value.currency : '')
}

const formatValueTerm = (value) => {
    return parseInt(value) +' '+ createLabel(parseInt(value), settings?.value?.local?.singleOffer?.days)
}

const handeDrag = (value, selector, minSelector = 'min', maxSelector = 'max') => {

    const firstLabel = document.querySelector(selector + ' .vue-slider-marks .vue-slider-mark:first-child');
    const lastLabel = document.querySelector(selector + ' .vue-slider-marks .vue-slider-mark:last-child');
    if(firstLabel) firstLabel.style.visibility = (value <= settings.value[minSelector] + 0.15 * (settings.value[maxSelector] - settings.value[minSelector])
        ? 'hidden' : 'visible')

    if(lastLabel) lastLabel.style.visibility = (value >= settings.value[maxSelector] - 0.15 * (settings.value[maxSelector] - settings.value[minSelector])
        ? 'hidden' : 'visible')

    calculateTotal()
}

// Инициализация значений из localStorage при создании компонента
onMounted(() => {
    const storedCalculatorValue = localStorage.getItem('calculatorValue');
    if (storedCalculatorValue) {
        calculatorValue.value = parseFloat(storedCalculatorValue);
    }

    ajax({
        action: "get_calculator_settings",
        cookies: getAllCookies(),
    }, (response) => {
        settings.value = response
        calculatorValue.value = localStorage.getItem('calculatorValue') ? parseInt(localStorage.getItem('calculatorValue')) : response.from
        total.value.rate = response.minRate ?? 0.01
        options = {
            silent: true,
            dotSize: 30,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [
                response.min,
                response.max
            ],
            min: response.min,
            max: response.max,
            interval: Number.isInteger((response.max - response.min) / response.step) ? response.step : 1,
            enableCross: true,
            hideCoveredLabels: true,
            tooltip: 'always',
            tooltipFormatter: value => formatValue(value, true),
            dotOptions: {
                disabled: false,
                style: {
                    border: '5px solid var(--color-primary)',
                    boxShadow: 'none'
                }
            }
        }

        termOptions = {
            silent: true,
            dotSize: 30,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [
                response.minTerm,
                response.maxTerm
            ],
            min: response.minTerm,
            max: response.maxTerm,
            interval: 1,
            enableCross: true,
            hideCoveredLabels: true,
            tooltip: 'always',
            tooltipFormatter: value => formatValueTerm(value),
            dotOptions: {
                disabled: false,
                style: {
                    border: '5px solid var(--color-primary)',
                    boxShadow: 'none'
                }
            }
        }
        termValue.value = parseInt((response.maxTerm - response.minTerm) * 0.8) ?? response.minTerm
        calculateTotal()
    });
});

</script>



<style scoped>
.calculator.lz {
    padding: 20px;
    margin: 20px auto;
}
.calculator.lz .calculatorTitle {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    padding: 20px 0;
}
.calculator.lz .calculatorBlocks{
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
}
.calculator.lz .label {
    height: auto;
    font-size: 16px;
    font-weight: 400;
}
.calculator.lz .vue-slider{
    margin: 40px 0 10px;
}
.calculator.lz .calculatorBlocks > div{
    flex: 1 1 auto;
}
.calculator.lz .settingsLine > div, .calculator.lz .settingsLine > a {
    width: 100%;
}
.calculator.lz .total {
    color: #1a1a1a;
    font-size: 18px;
}
.calculator.lz .total span{
    line-height: 1.6;
    letter-spacing: 0;
    font-size: 20px;
    color: var(--color-primary);
    font-weight: 400;
}
.calculator.lz a.getMoney {
    background-color: var(--color-primary);
    border-radius: 32px;
    border: none;
    width: 100%;
    min-width: 200px;
    color: #fff;
    text-align: center;
    display: block;
    text-decoration: none;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 18px;
    margin-top: 30px;
}
</style>